import { render, staticRenderFns } from "./ExpenseGroupEditModal.vue?vue&type=template&id=406fceff&scoped=true&"
import script from "./ExpenseGroupEditModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseGroupEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fceff",
  null
  
)

export default component.exports